import React from 'react';
import styled from '@emotion/styled';
import { Space } from 'antd';
import JobStatus, { STATUS_TYPE } from '../Status/JobStatus';

const StyledJobStatus = styled(JobStatus)`
  font-size: 10px;
  min-width: 30px;
  text-align: center;
  padding: 4px 8px;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  height: 20px;
  border-radius: 13px;
`;
type Props = {
  status: STATUS_TYPE;
  title: string;
  inspectorName: string;
};
const JobEventScheduleItem = (props: Props) => {
  const getTwoCharacters = React.useMemo(() => {
    const splited = (props.inspectorName || '').split(' ');
    const firstCharacter = splited[0][0];
    const secondCharacter = splited[1][0];
    return `${firstCharacter}${secondCharacter}`.toUpperCase();
  }, [props.inspectorName]);
  return (
    <Space align="center" size={0}>
      <StyledJobStatus alpha={1} status={props.status}>
        {getTwoCharacters}
      </StyledJobStatus>
      {props?.title}
    </Space>
  );
};

export default JobEventScheduleItem;
